// The type of a tournament (#536). The mirror of backend/src/lib/tournamentType.ts:
// the ONE place in the frontend that knows the values.
//
// Do not compare a type with a literal in a component. Ask for the behaviour:
//   runsAsOpenRing(type)       a matched bout may draw, the Check-in tab,
//                              Match Boxers.
//   hasChampionshipPart(type)  the Team Ratings tab, the Stage column of the
//                              print view.
//   drawsAfterCheckin(type)    the order of a hybrid day: the weigh-in first,
//                              then the brackets (#547).
// e2e/tests/tournament-type-helpers-536.spec.ts fails on a type literal in any
// other file, and it pins this file against the backend file.

export const TOURNAMENT_TYPES = ['championship', 'open_ring', 'hybrid'] as const;
export type TournamentType = typeof TOURNAMENT_TYPES[number];

/** The type that a new tournament form starts with. */
export const DEFAULT_TOURNAMENT_TYPE: TournamentType = 'championship';

/** The open-ring rules: a matched bout may draw, the Check-in tab (not the
 *  Weigh-in tab), and Match Boxers. The age-group derive does not depend on
 *  the type (#554). */
export function runsAsOpenRing(type: string | null | undefined): boolean {
  return type === 'open_ring' || type === 'hybrid';
}

/** A championship part: the Team Ratings tab (medals), and the Stage column of
 *  the print view. */
export function hasChampionshipPart(type: string | null | undefined): boolean {
  return type === 'championship' || type === 'hybrid';
}

/** The order of a hybrid day (operator, 2026-10-03, #547): weigh in every
 *  athlete first, End Check-in, the moves of the manager, and only then the
 *  brackets, the bout plan and Match Boxers. So the Boxers-tab pencil stays
 *  after End Check-in, and a bout before the bracket plan asks first. */
export function drawsAfterCheckin(type: string | null | undefined): boolean {
  return runsAsOpenRing(type) && hasChampionshipPart(type);
}
